import dayjs from "dayjs";

const number = value => (typeof value === "number" || typeof value === "string") &&
  String(value).trim() !== "" && Number.isFinite(Number(value)) ? Number(value) : null;
const recorded = value => value !== undefined && value !== null && value !== "";
const severe = "Desnutrici\u00f3n Aguda Severa";
const moderate = "Desnutrici\u00f3n Aguda Moderada";

function calendarDate(value) {
  if (!value) return null;
  const date = dayjs(value);
  if (!date.isValid()) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) && date.format("YYYY-MM-DD") !== value) return null;
  return Date.UTC(date.year(), date.month(), date.date());
}

export function nutritionAge({ fechaNacSalud, fechaActSalud, edadEnMeses } = {}) {
  // Keep the form's existing days/30.4375 age rule, but never substitute today for an absent visit date.
  if (fechaNacSalud) {
    const birth = calendarDate(fechaNacSalud);
    const visit = calendarDate(fechaActSalud);
    if (birth === null || visit === null || birth > visit) return { months: null };
    const days = Math.floor((visit - birth) / 86400000);
    return { months: Math.floor(days / 30.4375), years: Math.floor(days / 365.25),
      remainderMonths: Math.floor((days % 365.25) / 30.4375) };
  }
  const months = number(edadEnMeses);
  return { months: months !== null && months >= 0 ? months : null };
}

export function calculateM5Nutrition(input = {}) {
  const age = nutritionAge(input).months;
  const cmb = number(input.cmbM5);
  const z = number(input.puntajezM5);
  const edema = input.edema === "Si" || input.edema === "S\u00ed" || input.edema === true;
  let pb = "";
  let pbPriority = 0;
  let nutrition = "";
  let nutritionPriority = 0;
  // These bounds and priorities are the existing handlers' rules, including their uncovered intervals.
  if (age !== null && age >= 6 && age <= 59 && cmb !== null && cmb > 0) {
    if (cmb < 11.5) { pb = severe; pbPriority = 1; }
    else if (cmb >= 11.5 && cmb <= 12.4) { pb = moderate; pbPriority = 2; }
    else if (cmb >= 12.5) { pb = "Adecuado"; pbPriority = 5; }
  }
  if (z !== null && !edema) {
    if (z <= -3 && z >= -5) { nutrition = severe; nutritionPriority = 1; }
    else if (z <= -2 && z >= -2.99) { nutrition = moderate; nutritionPriority = 2; }
    else if (z <= 1.99 && z >= -1.99) { nutrition = "Adecuado"; nutritionPriority = 5; }
    else if (z >= 2 && z <= 2.99) { nutrition = "Sobrepeso"; nutritionPriority = 3; }
    else if (z >= 3) { nutrition = "Obesidad"; nutritionPriority = 4; }
  }
  let diagnosis = "";
  if (edema) diagnosis = severe;
  else if (z !== null) {
    if (pbPriority > 0 && nutritionPriority > 0) diagnosis = pbPriority < nutritionPriority ? pb : nutrition;
    else if (pbPriority > 0) diagnosis = pb;
    else if (nutritionPriority > 0) diagnosis = nutrition;
  }
  return { pbM5: pb, clasificacionNutM5: nutrition, diagFinalM5: diagnosis };
}

export function resolveM5Nutrition(input, stored = {}) {
  const calculated = calculateM5Nutrition(input);
  const result = { notes: {}, calculated };
  for (const key of ["pbM5", "clasificacionNutM5", "diagFinalM5"]) {
    const hasStored = recorded(stored[key]);
    result[key] = hasStored ? stored[key] : calculated[key];
    result.notes[key] = hasStored && calculated[key] && stored[key] !== calculated[key]
      ? `Difiere del c\u00e1lculo actual: ${calculated[key]}. Se conserva el valor registrado.`
      : !hasStored && calculated[key] ? "Valor calculado" : "";
  }
  return result;
}
